<script>
import {mapActions, mapState} from 'vuex';
import FormAlert from "../../core/FormAlert";
import LoadingButton from "../../core/LoadingButton";
import SignupFormSaveButton from "./SignupFormSaveButton";
import SignupFormResetButton from "./SignupFormResetButton";
import templatable from "@/mixins/templatable";
import BankAccountAddress3 from "@/components/configuration/signup/bank-account/BankAccountAddress3";
import BankAccountAddress2 from "@/components/configuration/signup/bank-account/BankAccountAddress2";
import BankAccountAddress1 from "@/components/configuration/signup/bank-account/BankAccountAddress1";
import BankAccountBankName from "@/components/configuration/signup/bank-account/BankAccountBankName";
import BankAccountSwift from "@/components/configuration/signup/bank-account/BankAccountSwift";
import BankAccountIban from "@/components/configuration/signup/bank-account/BankAccountIban";
import BankAccountNumber from "@/components/configuration/signup/bank-account/BankAccountNumber";
import BankAccountSortCode from "@/components/configuration/signup/bank-account/BankAccountSortCode";
import BankAccountBeneficiary from "@/components/configuration/signup/bank-account/BankAccountBeneficiary";
import SubscribeToNewsletter from "@/components/configuration/signup/SubscribeToNewsletter.vue";

// Billing Address inputs
import BillingZipCode from "@/components/configuration/signup/billing-address/BillingZipCode";
import BillingCity from "@/components/configuration/signup/billing-address/BillingCity";
import BillingState from "@/components/configuration/signup/billing-address/BillingState";
import BillingCountry from "@/components/configuration/signup/billing-address/BillingCountry";
import BillingAddress2 from "@/components/configuration/signup/billing-address/BillingAddress2";
import BillingAddress1 from "@/components/configuration/signup/billing-address/BillingAddress1";

// shipping Address inputs
import ShippingZipCode from "@/components/configuration/signup/shipping-address/ShippingZipCode";
import ShippingCity from "@/components/configuration/signup/shipping-address/ShippingCity";
import ShippingState from "@/components/configuration/signup/shipping-address/ShippingState";
import ShippingCountry from "@/components/configuration/signup/shipping-address/ShippingCountry";
import ShippingAddress2 from "@/components/configuration/signup/shipping-address/ShippingAddress2";
import ShippingAddress1 from "@/components/configuration/signup/shipping-address/ShippingAddress1";
import ShippingSameAsBillingAddress
  from "@/components/configuration/signup/shipping-address/ShippingSameAsBillingAddress";

import IsCompany from "@/components/configuration/signup/profile-information/IsCompany";
import Phone from "@/components/configuration/signup/profile-information/Phone";
import PreferredLanguage from "@/components/configuration/signup/profile-information/PreferredLanguage";
import CompanyName from "@/components/configuration/signup/profile-information/CompanyName";
import PersonalId from "@/components/configuration/signup/profile-information/PersonalId";
import TitleInput from "@/components/configuration/signup/profile-information/TitleInput";
import LastName from "@/components/configuration/signup/profile-information/LastName";
import MiddleName from "@/components/configuration/signup/profile-information/MiddleName";
import Initials from "@/components/configuration/signup/profile-information/Initials";
import Gender from "@/components/configuration/signup/profile-information/Gender";
import FirstName from "@/components/configuration/signup/profile-information/FirstName";
import Email from "@/components/configuration/signup/account-details/Email";
import Password from "@/components/configuration/signup/account-details/Password";
import PasswordConfirmation from "@/components/configuration/signup/account-details/PasswordConfirmation";
import IdentificationNumber from "@/components/configuration/signup/identification-fields/IdentificationNumber.vue";
import IdentificationType from "@/components/configuration/signup/identification-fields/IdentificationType.vue";
import PlaceOfIssue from "@/components/configuration/signup/identification-fields/PlaceOfIssue.vue";
import DocumentIssueDate from "@/components/configuration/signup/identification-fields/DocumentIssueDate.vue";
import DocumentExpirationDate from "@/components/configuration/signup/identification-fields/DocumentExpirationDate.vue";

import PersonalIdentificationDetails from './PersonalIdentificationDetails.vue'
import BankAccountDetails from './BankAccountDetails.vue'
import BillingAddressDetails from './BillingAddressDetails.vue'
import ShippingAddressDetails from './ShippingAddressDetails.vue'
import TermsAndConditions from "@/components/configuration/signup/TermsAndConditions.vue";
import InterestCheckboxes from "@/components/configuration/signup/InterestCheckboxes.vue";
import CustomerTerms from "@/components/configuration/signup/CustomerTerms.vue";
import VatNumber from "@/components/configuration/signup/customer-terms/VatNumber.vue";

export default {
  name: "SignupBody",
  mixins: [templatable('signupInputsTemplate')],
  components: {
    BankAccountAddress3,
    BankAccountAddress2,
    BankAccountAddress1,
    BankAccountBankName,
    BankAccountSwift,
    BankAccountIban,
    BankAccountNumber,
    BankAccountSortCode,
    BankAccountBeneficiary,
    SubscribeToNewsletter,
    TermsAndConditions,

    BillingAddressDetails,
    ShippingAddressDetails,

    BillingZipCode,
    BillingCity,
    BillingState,
    BillingCountry,
    BillingAddress2,
    BillingAddress1,

    ShippingSameAsBillingAddress,
    ShippingZipCode,
    ShippingCity,
    ShippingState,
    ShippingCountry,
    ShippingAddress2,
    ShippingAddress1,

    IsCompany,
    Phone,
    PreferredLanguage,
    CompanyName,
    PersonalId,
    TitleInput,
    LastName,
    MiddleName,
    Initials,
    Gender,
    FirstName,
    Email,
    Password,
    PasswordConfirmation,
    SignupFormResetButton,
    SignupFormSaveButton,
    LoadingButton,
    FormAlert,
    PersonalIdentificationDetails,
    BankAccountDetails,
    IdentificationNumber,
    IdentificationType,
    PlaceOfIssue,
    DocumentIssueDate,
    DocumentExpirationDate,
    InterestCheckboxes,
    CustomerTerms,
    VatNumber,
  },
  data: () => ({
    bankAccountFilled: false,
    paymentCompleted: false,
    template: `
      <div v-if="model" class="ta-signup-body">
      [[template]]
      </div>
    `
  }),
  props: {
    errors: {
      required: false,
      type: Object
    }
  },
  computed: {
    ...mapState({
      model: state => state.signup.model
    })
  },
  watch: {
    // 'model.bank_account': {
    //   deep: true,
    //   handler(newValue) {
    //     this.bankAccountFilled = Object.keys(newValue).filter(key => newValue[key] !== '').length > 0
    //     this.$emit('back-account-update', this.bankAccountFilled)
    //   }
    // },
  },
  methods: {
    ...mapActions(["getCountries", "getTitles"]),
    // eraseBankAccount() {
    //   Object.keys(this.model.bank_account).forEach(key => {
    //     this.model.bank_account[key] = ""
    //   });
    // },
  },
  async beforeMount() {
    await this.getCountries();
    await this.getTitles();
  }
}
</script>

<style scoped>

</style>
